/**
 * Truffle
 *
 * Exposes two WAR groups to http(s) origins with no `use_dynamic_url`: the static entries
 * injected-script/index.js, devtools/index.html and content-script/index.js, plus a
 * hashed `chunks/*-*.js` group. The static, vendor-directory-named scripts are fetchable
 * at fixed URLs from any page.
 *
 * We probe the stable named entries and deliberately avoid the chunks/ paths, whose names
 * carry a rotating build hash. Each chosen script sits in a vendor-named directory, so the
 * path is distinctive to Truffle.
 *
 * Manifest verified against version 4.7.1.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'bkkjeefjfjcfdfifddmkdmcpmaakmelp';

export const truffle: ExtensionDefinition = {
  id: ID,
  name: 'Truffle',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Static injected-script / content-script / devtools entries exposed to http(s) origins ' +
    'with no dynamic URL. We skip the hashed chunks/ paths and probe the stable ones.',
  signals: [
    {
      id: 'war-injected-script-index-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch injected-script/index.js — a static, vendor-directory-named script exposed ' +
        'to http(s) origins at a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'injected-script/index.js'),
    },
    {
      id: 'war-content-script-index-js',
      kind: 'web-accessible-resource',
      description: 'Fetch content-script/index.js — a second static entry, corroborating.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content-script/index.js'),
    },
    {
      id: 'war-devtools-index-html',
      kind: 'web-accessible-resource',
      description: 'Fetch devtools/index.html — the devtools panel page, a third path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'devtools/index.html'),
    },
  ],
};
